import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

export const handleError = (title, message) => {
  NotificationService.showNotification({
    title,
    notificationType: NOTIFICATION_TYPE_ERROR,
    content: message,
    duration: 3000,
  });
};
